interface IFixedRightBottom {
  backTop?: {
    scrollContainer: string;
    item: string;
    top?: number;
    total?: Ref<number> | number;
  };
  // contactUs: boolean
  onlineService: boolean;
}

export const useFixedRightBottom = () =>
  useState<IFixedRightBottom>('fixed-right-bottom', () => ({
    // contactUs: true,
    onlineService: true,
  }));

export const useBackToTop = (fn: () => IFixedRightBottom['backTop']) => {
  const option = useFixedRightBottom();

  // 保存 watchEffect 的停止函数，在组件卸载时调用
  const stopWatchEffect = watchEffect(() => {
    option.value.backTop = fn();
  });

  onBeforeRouteLeave(() => {
    option.value.backTop = undefined;
  });

  onBeforeRouteUpdate(() => {
    option.value.backTop = undefined;
  });

  // 组件卸载时停止 watchEffect
  onBeforeUnmount(() => {
    stopWatchEffect();
  });
};
